import React, { useState } from "react"

import { isMobile } from "@components/constants"
import { PropertyModal } from "@modules/backstage/properties"

import PropertiesList from "./PropertiesList"
import PropertiesTable from "./PropertiesTable"
import getSortedProperties from "./helpers/getSortedProperties"


const FundProperties = ({ properties = [], ...props }) => {
  const [ property, setProperty ] = useState()

  const sortedProperties = getSortedProperties(properties)

  const closeModal = () => setProperty(null)

  const openPropertyModal = propertyId => {
    const result = properties
      .find(({ id }) => id === propertyId)

    setProperty(result)
  }

  const content = isMobile
    ? <PropertiesList
        properties={sortedProperties}
        openPropertyModal={openPropertyModal}
      />
    : <PropertiesTable
        {...props}
        properties={sortedProperties}
        openPropertyModal={openPropertyModal}
      />

  return (
    <>
      {content}

      <PropertyModal
        property={property}
        onCancel={closeModal}
      />
    </>
  )
}

export default FundProperties
